import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@src/components/Image';
import './styles.scss';

export function Preview({ imageSrc, title, description }) {
  return (
    <div className="premium-service-review">
      <div className="premium-service-review__image-wrapper">
        <Image className="premium-service-review__image" src={imageSrc} />
      </div>

      <div className="premium-service-review__content">
        <div className="premium-service-review__content-title">{title}</div>
        <div className="premium-service-review__content-description">{description}</div>
      </div>
    </div>
  );
}

Preview.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
